// What the team roles (TC, Marketing Manager, Local Assistant) can see and change.
// Mirrored server-side in functions/mcp/policy.js. Keep the two in step.
import { normalizeRole } from './roles';

export const TEAM_ROLES = ['TC', 'Marketing Manager', 'Local Assistant'];
export const isTeamRole = (role) => TEAM_ROLES.includes(normalizeRole(role));

// Sections hidden from the menu and blocked by route for team roles. Open houses and calendar stay.
export const TEAM_HIDDEN_PATHS = ['/website', '/performance', '/training'];
// Limited Agent (role value 'limited_agent'): a reusable agent role with a smaller app.
// Sees only deals she owns or co-agents on; transaction tasks only (no lead tasks); no Leads/CRM, Pipeline,
// Website, dashboard announcements or points; no quick actions or email/text (Quo) buttons on deals.
// Deals she creates get the team leader (Kelly) as co-agent automatically. Mirrored in functions/mcp/policy.js
// and database.rules.json.
export const LIMITED_AGENT = 'limited_agent';
export const isLimitedAgent = (role) => normalizeRole(role) === LIMITED_AGENT;
export const LIMITED_HIDDEN_PATHS = ['/leads', '/inbox', '/crm', '/pipeline', '/website'];
// The co-agent added to every deal a Limited Agent creates (Kelly, the team leader).
export const LIMITED_AGENT_COAGENT = { uid: 'izVJWBDFcgZRFM1lzFDd8K5P6bU2', email: 'kelly.olin@exprealty.com', name: 'Kelly Olin' };

// Agent-like roles: work their own deals the way an Agent does.
export const isAgentLike = (role) => ['Agent', LIMITED_AGENT].includes(normalizeRole(role));

// Feature switches by role (true = shown).
export const canUseQuickActions = (role) => !isLimitedAgent(role);
export const canUseCommsButtons = (role) => !isLimitedAgent(role);
export const showsAnnouncements = (role) => !isLimitedAgent(role);
export const showsPoints = (role) => !isLimitedAgent(role);
export const showsLeadTasks = (role) => !isLimitedAgent(role);
export const showsGoogleReviewField = (role) => !isLimitedAgent(role);

const startsWithAny = (list, path) => list.some((p) => path === p || String(path || '').startsWith(`${p}/`));
export const isPathBlockedForRole = (role, path) =>
  (isTeamRole(role) && startsWithAny(TEAM_HIDDEN_PATHS, path))
  || (isLimitedAgent(role) && startsWithAny(LIMITED_HIDDEN_PATHS, path));

// Admin, TC and Marketing Manager can edit anything on any deal. Agents edit their own deals.
// Local Assistant can read every deal but edits only items that are hers.
export const EDIT_ANY_DEAL_ROLES = ['Admin', 'TC', 'Marketing Manager'];
export const canEditAnyDeal = (role) => EDIT_ANY_DEAL_ROLES.includes(normalizeRole(role));
export const canEditDeal = (role, uid, ownerUid) => canEditAnyDeal(role) || !ownerUid || ownerUid === uid;

// A task is the Local Assistant's when it is a Local Assistant task or assigned to her.
export const isTaskHers = (task, uid) => !!task && (
  (task.role || '') === 'Local Assistant' || (uid && (task.assignee === uid || task.assigneeUid === uid || task.assignedTo === uid))
);
export const canEditTask = (task, role, uid, ownerUid) => {
  const r = normalizeRole(role);
  if (r === 'Local Assistant') return isTaskHers(task, uid);
  if (canEditAnyDeal(r)) return true;
  return true; // agents: unchanged (they only see tasks on deals they own or co-agent on)
};
